import { render } from "./StorePromoUsageTable.vue?vue&type=template&id=8c60f226&scoped=true"
import script from "./StorePromoUsageTable.vue?vue&type=script&lang=js"
export * from "./StorePromoUsageTable.vue?vue&type=script&lang=js"

import "./StorePromoUsageTable.vue?vue&type=style&index=0&id=8c60f226&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c60f226"]])

export default __exports__